"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalGrossValue = exports.totalNetValue = exports.computeYearlyNetIncome = exports.computeBorrowingCapacity = exports.computeNetGain = exports.computeSellingPrice = exports.netValue = exports.grossValue = exports.movementValueBetween = exports.computeSRD = exports.recurrentPercentageEvolution = exports.daysBetween = exports.monthsBetween = exports.amountFromEuro = exports.amountInEuro = exports.defaultOptions = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var decimal_js_light_1 = __importDefault(require("decimal.js-light"));
var lodash_1 = __importDefault(require("lodash"));
var models_1 = require("../models");
exports.defaultOptions = {
    debug: false,
};
var amountInEuro = function (amount, currency) { return amount * currency.rateToEuro; };
exports.amountInEuro = amountInEuro;
var amountFromEuro = function (amount, currency) { return amount / currency.rateToEuro; };
exports.amountFromEuro = amountFromEuro;
var monthsBetween = function (date1, date2) { return dayjs_1.default(date2).diff(date1, 'months'); };
exports.monthsBetween = monthsBetween;
var daysBetween = function (date1, date2) { return dayjs_1.default(date2).diff(date1, 'days'); };
exports.daysBetween = daysBetween;
// Percentage representing the reccurent evolution of +perc each times, N times
var recurrentPercentageEvolution = function (N, Perc, options) {
    if (options === void 0) { options = exports.defaultOptions; }
    if (options.debug) {
        console.log({
            N: N,
            Perc: Perc,
        });
    }
    return Math.pow(1 + Perc, N) - 1;
};
exports.recurrentPercentageEvolution = recurrentPercentageEvolution;
var mensCX = function (Mens, prevSRD, im, options) {
    if (options === void 0) { options = exports.defaultOptions; }
    if (options.debug) {
        console.log({
            Mens: Mens,
            prevSRD: prevSRD.toNumber(),
            im: im.toNumber(),
        });
    }
    return new decimal_js_light_1.default(Mens).minus(im.times(prevSRD));
};
var computeSRDX = function (Mens, prevSRD, im, options) {
    if (options === void 0) { options = exports.defaultOptions; }
    return prevSRD.minus(mensCX(Mens, prevSRD, im, options));
};
var computeSRD = function (Mens, ME, im, X, options) {
    if (options === void 0) { options = exports.defaultOptions; }
    return Array(X).fill(undefined).reduce(function (SRDX, _, x) {
        if (SRDX.eq(0))
            return SRDX;
        var newSRDX = computeSRDX(Mens, SRDX, im);
        if (newSRDX.lessThan(0)) {
            newSRDX = new decimal_js_light_1.default(0);
        }
        if (options.debug) {
            console.log({
                x: x + 1,
                prevSRD: SRDX.toNumber(),
                MenCX: newSRDX.eq(0) ? SRDX.toNumber() : mensCX(Mens, SRDX, im, options).toNumber(),
                SRDX: newSRDX.toNumber(),
            });
        }
        return newSRDX;
    }, new decimal_js_light_1.default(ME));
};
exports.computeSRD = computeSRD;
var netLoanValue = function (loan, date, options) {
    if (options === void 0) { options = exports.defaultOptions; }
    if (dayjs_1.default(loan.subscriptionDate).isAfter(date))
        return new decimal_js_light_1.default(0);
    var ME = loan.amount;
    var Mens = loan.monthlyAmount;
    var D = loan.subscriptionDate;
    var X = exports.monthsBetween(D, date);
    var ia = loan.yearlyRate;
    var im = new decimal_js_light_1.default(ia).plus(1).pow(1 / 12).minus(1);
    var SRD = exports.computeSRD(Mens, ME, im, X, options);
    if (options.debug) {
        console.log({
            loan: loan,
            ME: ME,
            Mens: Mens,
            D: D,
            X: X,
            ia: ia,
            im: im.toNumber(),
            SRD: SRD.toNumber(),
        });
    }
    return SRD.times(loan.sharePercentage);
};
var intervalFromRecurrence = function (nbOccurrence, period) {
    switch (period) {
        case models_1.MovementPeriod.week: return 7 / nbOccurrence;
        case models_1.MovementPeriod.month: return 30 / nbOccurrence;
        case models_1.MovementPeriod.year: return 365 / nbOccurrence;
        case models_1.MovementPeriod.once: return 1;
    }
};
var countRecurrences = function (periodicOccurrences, period, initialDate, startDate, endDate) {
    var count = 0;
    var timeStamp = initialDate.getTime();
    var startDateTs = startDate.getTime();
    var interval = intervalFromRecurrence(periodicOccurrences, period) * 24 * 60 * 60 * 1000;
    while (timeStamp < startDateTs) {
        timeStamp += interval;
    }
    var endDateTs = endDate.getTime();
    while (timeStamp < endDateTs) {
        count++;
        timeStamp += interval;
    }
    return count;
};
var movementValueBetween = function (movement, startDate, endDate) {
    if (movement.period === models_1.MovementPeriod.once) {
        if (dayjs_1.default(movement.startDate).isSame(startDate) || (dayjs_1.default(movement.startDate).isAfter(startDate) && dayjs_1.default(movement.startDate).isBefore(endDate)))
            return new decimal_js_light_1.default(movement.amount);
        else
            return new decimal_js_light_1.default(0);
    }
    startDate = new Date(Math.max(new Date(movement.startDate).getTime(), startDate.getTime()));
    endDate = movement.endDate ? new Date(Math.min(new Date(movement.endDate).getTime(), endDate.getTime())) : endDate;
    var nbMovement = countRecurrences(movement.nbOccurrence, movement.period, movement.startDate, startDate, endDate);
    return new decimal_js_light_1.default(nbMovement).times(movement.amount);
};
exports.movementValueBetween = movementValueBetween;
var grossValue = function (asset, date, ownedOnly, options) {
    var _a, _b;
    if (date === void 0) { date = new Date(); }
    if (ownedOnly === void 0) { ownedOnly = false; }
    if (options === void 0) { options = exports.defaultOptions; }
    var referenceDate = (_a = asset.valueDate) !== null && _a !== void 0 ? _a : asset.acquisitionDate;
    var referenceValue = (_b = asset.currentValue) !== null && _b !== void 0 ? _b : asset.acquisitionValue;
    if (referenceValue === undefined || referenceValue === null)
        throw new Error("invalid asset, both values are non-defined");
    var N = exports.monthsBetween(referenceDate, date);
    var VA = new decimal_js_light_1.default(referenceValue);
    var ea = new decimal_js_light_1.default(asset.evolutionRate || 0);
    var em = ea.plus(1).pow(1 / 12).minus(1);
    var ed = ea.plus(1).pow(1 / 365).minus(1);
    var Pattr = asset.sharePercentage || 1;
    var VF = VA;
    var vfComputingDate = dayjs_1.default(referenceDate);
    var _loop_1 = function (month) {
        var previousDate = vfComputingDate;
        vfComputingDate = vfComputingDate.add(1, 'month');
        var movementsValue = asset.movements.reduce(function (sum, m) { return sum.plus(exports.movementValueBetween(m, previousDate.toDate(), vfComputingDate.toDate())); }, new decimal_js_light_1.default(0));
        VF = VF.plus(movementsValue).times(em.plus(1));
    };
    for (var month = 0; month < N; month++) {
        _loop_1(month);
    }
    var remainingDays = exports.daysBetween(vfComputingDate.toDate(), date);
    var _loop_2 = function (day) {
        var previousDate = vfComputingDate;
        vfComputingDate = vfComputingDate.add(1, 'day');
        var movementsValue = asset.movements.reduce(function (sum, m) { return sum.plus(exports.movementValueBetween(m, previousDate.toDate(), vfComputingDate.toDate())); }, new decimal_js_light_1.default(0));
        VF = VF.plus(movementsValue).times(ed.plus(1));
    };
    for (var day = 0; day < remainingDays; day++) {
        _loop_2(day);
    }
    // Finally, apply the patrimoine sharing if required
    if (ownedOnly)
        VF = VF.times(Pattr);
    if (options.debug) {
        console.log({
            asset: asset,
            date: date,
            N: N,
            VA: VA.toNumber(),
            ea: ea.toNumber(),
            em: em.toNumber(),
            VF: VF.toNumber(),
            Pattr: Pattr,
        });
    }
    return VF.toNumber();
};
exports.grossValue = grossValue;
var netValue = function (asset, date, options) {
    if (date === void 0) { date = new Date(); }
    if (options === void 0) { options = exports.defaultOptions; }
    if (dayjs_1.default(asset.acquisitionDate).isAfter(date))
        return 0;
    var VF = exports.grossValue(asset, date, false, options);
    var Pattr = asset.sharePercentage || 1;
    var SRDF = asset.loans.reduce(function (sum, loan) { return sum.plus(netLoanValue(loan, date, options)); }, new decimal_js_light_1.default(0));
    if (options.debug) {
        console.log({
            asset: asset,
            date: date,
            VF: VF,
            SRDF: SRDF.toNumber(),
            Pattr: Pattr,
        });
    }
    var total = new decimal_js_light_1.default(VF).times(Pattr).minus(SRDF);
    return total.toNumber();
};
exports.netValue = netValue;
var computeSellingPrice = function (va, evolurationRate, varN) {
    return va * Math.pow((1 + evolurationRate), (varN / 12));
};
exports.computeSellingPrice = computeSellingPrice;
var computeNetGain = function (fpi, pv, fav, soldeRestantDu, precompte, agence, entretien, autresFrais, varN, mens, lmens, tloc, tr, vaTTC) {
    var charges = (precompte + agence + entretien + autresFrais) * varN / 12;
    var pvTC = pv * (1 - fav);
    var appreciationFees = tr * (pv - vaTTC);
    var montantInvestiPendantN = (mens - lmens * tloc) * varN;
    var fpf = pvTC - soldeRestantDu - charges - montantInvestiPendantN - appreciationFees;
    return fpf - fpi;
};
exports.computeNetGain = computeNetGain;
var computeBorrowingCapacity = function (incomes, expenses, currency, maxDebtRatio) {
    if (!maxDebtRatio)
        return undefined;
    var euroNetIncome = exports.computeYearlyNetIncome(incomes, expenses, { rateToEuro: 1 });
    var euroBorrowingCapacity = euroNetIncome * maxDebtRatio;
    return exports.amountFromEuro(euroBorrowingCapacity, currency);
};
exports.computeBorrowingCapacity = computeBorrowingCapacity;
var periodicityFactor = {
    month: 12,
    year: 1
};
var computeYearlyNetIncome = function (incomes, expenses, currency) {
    var entityValue = function (e) {
        if (e.amount === undefined || !e.periodicity)
            return 0;
        return exports.amountInEuro(e.amount, e.currency) * periodicityFactor[e.periodicity];
    };
    var allIncome = lodash_1.default.sumBy(incomes, entityValue);
    var allExpenses = lodash_1.default.sumBy(expenses, entityValue);
    var netIncome = allIncome - allExpenses;
    return exports.amountFromEuro(netIncome, currency);
};
exports.computeYearlyNetIncome = computeYearlyNetIncome;
var totalNetValue = function (assets, currency, date, options) {
    if (date === void 0) { date = new Date(); }
    if (options === void 0) { options = exports.defaultOptions; }
    var amounts = assets.map(function (asset) { return exports.amountInEuro(exports.netValue(asset, date, options), asset.currency); });
    var totalInEuro = lodash_1.default.sum(amounts);
    return exports.amountFromEuro(totalInEuro, currency);
};
exports.totalNetValue = totalNetValue;
var totalGrossValue = function (assets, currency, date, ownedOnly, options) {
    if (date === void 0) { date = new Date(); }
    if (ownedOnly === void 0) { ownedOnly = false; }
    if (options === void 0) { options = exports.defaultOptions; }
    var amounts = assets.map(function (asset) { return exports.amountInEuro(exports.grossValue(asset, date, ownedOnly, options), asset.currency); });
    var totalInEuro = lodash_1.default.sum(amounts);
    return exports.amountFromEuro(totalInEuro, currency);
};
exports.totalGrossValue = totalGrossValue;
